import { styled } from '@compiled/react';
import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

export type { FloatingToolbarButtonStyleType } from './titleareaContentComponentsTypes';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmptyTitleArea = styled.div<{ isTemplateEditor?: boolean }>({
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: (props) => (props.isTemplateEditor ? '87px' : '113px'),
});

export const TitleAreaContentComponents = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TitleAreaContentComponents" */ './TitleAreaContentComponents'
			)
		).TitleAreaContentComponents,
	loading: (props) => <EmptyTitleArea isTemplateEditor={props.isTemplateEditor} />,
});

export { AlignmentButtonContainer } from './AlignmentButtonContainer';
export {
	ContentComponentsContext,
	ContentComponentsContextProvider,
	useContentComponentsContext,
} from './ContentComponentsContext';
